import { booleanIntersects } from '@turf/turf';
// 获取与自定义区域交互的线索区
self.onmessage = (event)=>{
  const { data, geojson } = event.data;
  const list = [];
  (data || []).forEach(item=>{
    const { scanSatellitePolygon } = item;
    const flag = booleanIntersects(JSON.parse(scanSatellitePolygon), geojson);
    flag && list.push(item);
  })
  self.postMessage({
    result: list,
  });
}